import { Box } from '@mui/material';
import BSCircularProgress from './circularProgress';
import LoaderBrand from './loaderBrand';

const FullPageLoader = ({ caption }) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    gap={3}
    minHeight="100vh"
    width="100%">
    <LoaderBrand />
    <BSCircularProgress caption={caption} />
  </Box>
);

export default FullPageLoader;
